import './divineevents/style';
import FormStructure from './divineevents/form_structure';

export default FormStructure;